export default "__VITE_ASSET__Dm6jJ22P__"